export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f42a0e1d183c4648b1ec458eefeacc98527443fce&name=fetchTypeahead!'